import "./App.css";

import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import FeaturedProject from "./components/FeaturedProject/FeaturedProject";
import Projects from "./components/Projects/Projects";
import Certifications from "./components/Certifications/Certifications";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
    {/* Explicitly wrap the Navbar to isolate its layer position */}
      <div className="relative z-[100]">
        <Navbar />
      </div>
      {/* <Navbar /> */}
      <Hero />
      <About />
      <Skills />
      <Experience />
      {/* <FeaturedProject /> */}
      <Projects />
      <Certifications />
      <Contact />
      <Footer />
    </>
  );
}

export default App;